import {
  FormGroup,
} from 'reactstrap';
import {
  createProperEndpoint,
  getPropersEndpoint,
  deactivateProperEndpoint,
  activateProperEndpoint,
  updateProperPasswordEndpoint,
} from '../propers/services/properService';
import { UserManagerServices } from '../../hooks/useUserManager';
import UserGenericForm from '../../components/UserGenericForm';
import Select from 'react-select';
import { Controller } from 'react-hook-form';

const BUSINESS_OPTIONS = [
  { value: 'for_rent', label: 'Renta' },
  { value: 'for_sale', label: 'Venta' },
  { value: 'for_pre_sale', label: 'Preventa' },
  { value: 'for_pcv', label: 'PCV' },
];

const PropersUser = () => {
  const developerServices: UserManagerServices = {
    create: createProperEndpoint,
    list: (_contextId, token) => getPropersEndpoint(token),
    deactivate: deactivateProperEndpoint,
    activate: activateProperEndpoint,
    updatePassword: updateProperPasswordEndpoint,
  };

  return (
    <UserGenericForm
      services={developerServices}
      pageName="Propers"
      pageParentName="Usuarios Internos"
      getRolesPath={(userId) =>
        `/internal-users/propers/${userId}/roles-management`
      }
      showPasswordOnReset={false}
      renderExtraFields={(control, errors) => (
        <FormGroup>
          <label className="form-control-label" htmlFor="bussiness_assigned">
            Negocio asignado
          </label>
          <Controller
            name="bussiness_assigned"
            control={control}
            render={({ field }) => (
              <Select
                isMulti
                options={BUSINESS_OPTIONS}
                value={BUSINESS_OPTIONS.filter((o) =>
                  field.value?.includes(o.value)
                )}
                onChange={(selected) =>
                  field.onChange(selected.map((s) => s.value))
                }
                placeholder="Seleccionar negocio..."
              />
            )}
          />
          {errors.bussiness_assigned && (
            <h5 className="text-danger">
              {errors.bussiness_assigned.message}
            </h5>
          )}
        </FormGroup>
      )}
    />
  );
};

export default PropersUser;
